

export const Cricle = ({color}) => {

    return(
        <div className={'cricle'} style={{background: color}}/>
    )
}